import { useEffect } from "react";
import Lenis from "lenis";

export function useLenis() {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 1,
            touchMultiplier: 1.2,
        });

        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);

        // Handle hash links via Lenis
        const handleHash = (e) => {
            const target = e.target.closest('a[href^="#"], a[href*="/#"]');
            if (!target) return;
            const href = target.getAttribute("href");
            const hash = href.includes("#") ? "#" + href.split("#")[1] : null;
            if (!hash || hash === "#") return;
            const el = document.querySelector(hash);
            if (el) {
                e.preventDefault();
                lenis.scrollTo(el, { offset: -80, duration: 1.3 });
            }
        };
        document.addEventListener("click", handleHash);

        return () => {
            document.removeEventListener("click", handleHash);
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);
}
